export default __webpack_public_path__ + "static/media/Greendownward.5ce8903c.svg";